import React from 'react';
import { Title } from '../../components/title';
import { createCn } from 'bem-react-classname';

import './style.css';

const cn = createCn('faq');

export const Faq = React.memo(() => {
    return (
        <div className={ cn() }>
            <div><Title title={ 'Faq' }/></div>
        </div>
    );
});
